import React, { Component } from 'react';
import { Modal, Toast } from 'antd-mobile';
import { Link } from 'react-router-dom';
import Http from '../../config/axiosUtils';
import { Helmet } from 'react-helmet';
import md5 from 'blueimp-md5';

import PayPwd from '../../components/pay/PayPwd';
import '../../assets/scss/Wallet/withdraw.scss';

class Withdraw extends Component {
  constructor() {
    super();
    this.state = {
      withdrawData: {},
      isBindBank: false, //是否已有银行卡
      isShowPwd: false, //弹出支付密码
      pwdError: false, //密码是否正确
      isNeedUploadCard: 0,// 是否需要上传身份证，1-需要 , 0 -更新身份有效期
      cardValidDate: '', //身份证有效期

    }
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const path = '/spread/web/spread/wallet/withdraw/info';
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        withdrawData: res.data,
        isBindBank: res.data.bankInfo !== null,
        isNeedUploadCard: res.data.isNeedUploadCard,
        cardValidDate: res.data.cardValidDate,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  submit = () => {
    if ((this.state.isBindBank === false) || (this.state.isNeedUploadCard === 1)) return;
    if (Number(this.state.withdrawData.withdrawAmount) === 0) {
      Toast.info('您的可提现金额为0！', 2);
      return;
    }
    if (this.state.withdrawData.payPasswordStatus !== 1) {
      Modal.alert('提示', '您暂未设置交易密码，请先设置！', [{ text: '取消', onPress: () => console.log('cancel') }, { text: '去设置', onPress: this.setPassword }]);
      return;
    }
    this.setState({
      isShowPwd: true
    })
  }

  setPassword = () => {
    this.props.history.push('/password');
  }

  closePayPwd = () => {
    this.setState({
      isShowPwd: false
    })
  }

  sureInput = async (value) => {
    const path = '/spread/web/spread/wallet/withdraw/submit';
    const postData = {
      password: md5(value)
    }
    const res = await Http.post(path, postData);
    if (res.code === 0) {
      this.setState({
        isShowPwd: false,
        pwdError: false
      })
      window.sessionStorage.setItem('withdrawRes', JSON.stringify(res.data));
      this.props.history.replace('/withdrawRes');
    } else {
      this.setState({
        pwdError: true,
        isShowPwd: false,
      });
      Toast.fail(res.msg, 2);
    }
  }

  isShowAddID = (value, date) => {
      return (<div className='card'>
        <div className='card-name'>
          <div className='card-name-title'>{!value ? '身份证' : '身份证照片'}</div>
          {
            !value && (<div className='card-name-bank'>有效期：{date}</div>)
          }
          
        </div>
        <Link to='/idCard'>
          <div className='card-add'>{!value ? '更新身份证有效期' : '添加身份证照片'}<i className='iconfont icon-arrrow_w'></i></div>
        </Link>
      </div>);
  }

  render() {
    const { withdrawData, isBindBank,isNeedUploadCard, cardValidDate } = this.state;
    let element = this.isShowAddID(isNeedUploadCard, cardValidDate);
    return (
      <div>
        <Helmet><title>提现</title></Helmet>
        <div className='withdraw'>
          <div className='top'>
            <div className='top-amount'>
              <div>提现金额(元)</div>
              <div className='top-amount-num'>&yen;{withdrawData.withdrawAmount}</div>
              <div className='top-amount-use'>可提现金额(元): <span>{withdrawData.withdrawAmount}</span></div>
            </div>
            <div className='top-num'>
              <div>实际到账金额(元): {withdrawData.incomeAmount}</div>
              <div>扣税金额(元): {withdrawData.taxAmount}</div>
            </div>
          </div>
          <div className='card'>
            <div className='card-name'>
              <div className='card-name-title'>银行卡</div>
              {isBindBank && <div className='card-name-bank'>{withdrawData.bankInfo}</div>}
            </div>
            <Link to='/bindCard'>
              <div className='card-add'>{isBindBank ? '更换' : '添加'}银行卡<i className='iconfont icon-arrrow_w'></i></div>
            </Link>
          </div>
          {element}
          <div className={`submit ${((isBindBank === false) || (isNeedUploadCard === 1) ||withdrawData.withdrawAmount === '0.00' ) ? 'high' : ''}`} onClick={this.submit}>提交</div>
          <Link to='/taxRule'>
            {/*<div className='rule'>扣税规则</div>*/}
          </Link>
        </div>
        {this.state.isShowPwd && <PayPwd sureInput={this.sureInput} closePayPwd={this.closePayPwd} pwdError={this.state.pwdError}></PayPwd>}
      </div>
    )
  }
}

export default Withdraw;
